"use client";

import { useEffect, useRef } from "react";
import { gsap } from "gsap";

import { cn } from "@/lib/utils";

export function AnimatedSectionDescription({
  children,
  className,
  delay = 0,
}: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}) {
  const ref = useRef<HTMLParagraphElement | null>(null);

  useEffect(() => {
    if (!ref.current) return;

    const element = ref.current;
    const ctx = gsap.context(() => {
      gsap.fromTo(
        element,
        { y: 14, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.55, delay, ease: "power2.out" }
      );
    }, element);

    return () => ctx.revert();
  }, [delay]);

  return (
    <p ref={ref} className={cn(className)}>
      {children}
    </p>
  );
}
